import { track } from '../utils';

export function trackInternalUpdatesCreation(
  studioName: string,
  relatedTo: string | null,
  relatedInfo: string[],
  numberOfAssets: number,
  dueDate: string | null,
  updatePriority: string | null,
) {
  track('Internal Update Created', {
    Studio: studioName,
    'Related To': relatedTo,
    'Related Info': relatedInfo,
    '# of Affected items': numberOfAssets,
    'Due Date': dueDate,
    'Update Priority': updatePriority,
  });
}
